import TableSortHeader from 'components/TableSortHeader'

export const ProgramsColumns = [
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Title</TableSortHeader>,
		accessor: 'col1',
		name: 'title',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Type</TableSortHeader>,
		accessor: 'col2', // accessor is the "key" in the data
		name: 'type',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Assignee</TableSortHeader>,
		accessor: 'col3',
		name: 'assignee',
		sortable: true,
	},
	{
		Header: 'Enrollment Date',
		accessor: 'col4',
		name: 'enrollmentDate',
		sortable: true,
	},
	{
		Header: 'Participant ID',
		accessor: 'col5',
		name: 'patientProgramId',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Start Date</TableSortHeader>,
		accessor: 'col6',
		name: 'startDate',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>End Date</TableSortHeader>,
		accessor: 'col7',
		name: 'endDate',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Condition</TableSortHeader>,
		accessor: 'col8',
		name: 'condition',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Applicable for</TableSortHeader>,
		accessor: 'col9',
		name: 'gender',
		sortable: true,
	},
]

export enum MEMBER_PROGRAMS_FILTER_FIELDS {
	SEARCH = 'Search',
}

export enum FIELD_NAMES {
	PROGRAM = 'program',
	CLIENT = 'client',
	ENROLLMENT = 'enrollment',
}

export enum ENROLL_STATUS {
	ACTIVE = 'active',
	COMPLETED = 'completed',
	RE_ENROLLED = 're-enrolled',
	IN_PROGRESS = 'inProgress',
	IN_REVIEW = 'inReview',
	REJECTED = 'rejected',
	EXPIRED = 'expired',
	NOT_ENROLLMENT = 'notEnrolled',
}

export enum ENROLL_TABLE_STATUS {
	IN_PROGRESS = 'In-Progress',
	IN_REVIEW = 'In-Review',
	NOT_ENROLLMENT = 'Not Enrolled',
}
